import React, { Component } from 'react';
import PropTypes from 'prop-types';

const placeholderForEmpty = 'This field cannot be empty';

export default class LoginForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      usernamePlaceholder: null,
      passwordPlaceholder: null,
    };
    this.submitForm = this.submitForm.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  submitForm(e) {
    //strange logic from the old site
    if(e.target.username.value.length === 0){
      this.setState({
        usernamePlaceholder: placeholderForEmpty
      })
    }
    else if(e.target.password.value.length === 0) {
      this.setState({
        passwordPlaceholder: placeholderForEmpty
      })
    }
    else {
      this.setState({
        username: e.target.username.value,
        password: e.target.password.value
      }, () => {
        this.props.handler({
          username: this.state.username,
          password: this.state.password
        });
      });
    }
    e.preventDefault();
  }

  render() {
    return (
      <div>
        <form onSubmit={this.submitForm}>
          <div className="form-group">
            <label>Username or Email</label>
            <input
              type="text"
              name="username"
              onChange={(value) => this.onChange(value)}
              className="form-control"
              placeholder={this.state.usernamePlaceholder}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              onChange={(value) => this.onChange(value)}
              className="form-control"
              placeholder={this.state.passwordPlaceholder}
            />
          </div>
          <input type="submit" className="btn btn-info col-md-12" value={'Submit'} />
        </form>
      </div>
    );
  }
}

LoginForm.propTypes = {
  handler: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/common/LoginForm/index.js